module.exports = __webpack_public_path__ + "newsletter-b6217efce81fecdc4b66.png";